import React from "react";
import "./styles.scss";
import SunroofLogo from "../../assets/images/sunroof-logo.svg";

const LoadingTopBar = () => {
  return (
    <>
      <div className="loading-top-nav">
        <span>
          {" "}
          <img src={SunroofLogo} />{" "}
        </span>
        <span>
          {" "}
          <a href="tel:18004017716">Call us</a>{" "}
        </span>
      </div>
    </>
  );
};

export default LoadingTopBar;
